import _defineProperty from 'babel-runtime/helpers/defineProperty';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Icon from '../Icon';
import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

import { styles, utils } from 'gipsy-misc';

var propTypes = {
  paramName: PropTypes.string,
  /* isRequired, methods called on every change (write or keyup/down) to update the parent value */
  onChange: PropTypes.func.isRequired,

  /* do not use these props below but access the duplicated state prop instead */

  /* should be a 24h format number, it will be converted as 12h if necessary */
  hour: PropTypes.number,
  minute: PropTypes.number,

  /* by default, if format is 12, period will be shown */
  showPeriod: PropTypes.bool,

  /* show or hide + - buttons */
  showIncrementButtons: PropTypes.bool,
  incrementBy: PropTypes.number,

  /*
    12h : the hour value will be compute and sent to the parent as 24h format ('03' with 'PM' will be sent as 15)
    anything else (or null) : user can write any number between minHour and maxHour, it will be sent as written to the parent
  */
  format: PropTypes.string,
  maxHour: PropTypes.number,
  minHour: PropTypes.number,
  maxMinute: PropTypes.number,
  minMinute: PropTypes.number
};

var TimeInput = function (_PureComponent) {
  _inherits(TimeInput, _PureComponent);

  function TimeInput(props) {
    _classCallCheck(this, TimeInput);

    var _this = _possibleConstructorReturn(this, (TimeInput.__proto__ || Object.getPrototypeOf(TimeInput)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.getStateFromProps(props);
    return _this;
  }

  _createClass(TimeInput, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var filterFields = ['hour', 'minute', 'format', 'maxHour', 'minHour', 'maxMinute', 'minMinute'];

      if (!isEqual(pick(this.props, filterFields), pick(nextProps, filterFields))) {
        var nextState = this.getStateFromProps(nextProps);
        this.setState(nextState);
      }
    }

    /* work with string|int value, (called with string when keyboard writing, int when increment (keyboard up/down & - + button)) */


    /* make sure the state is clean : 2 digits hour|minute valid string */


    /* return an object {paramName, value} to send to parent with int hour|minute, hour is converted to 24 format */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          hour = _state.hour,
          minute = _state.minute,
          period = _state.period,
          showPeriod = _state.showPeriod,
          showIncrementButtons = _state.showIncrementButtons,
          incrementBy = _state.incrementBy;


      return React.createElement(
        'div',
        { className: 'time-input', onClick: utils.DOM.stopPropagation, onBlur: this.onBlur },
        React.createElement(
          'div',
          { className: 'time input-container' + (showIncrementButtons ? ' increment-buttons' : '') },
          showIncrementButtons && React.createElement(
            'span',
            {
              className: 'decrement-button',
              onClick: function onClick() {
                _this2.increment('minute', parseInt(hour) === 0 && minute <= incrementBy ? -5 : -incrementBy);
              } },
            React.createElement(Icon, { icon: 'Substract', size: 10 })
          ),
          React.createElement('input', {
            className: 'gp-input hour',
            ref: function ref(_ref) {
              _this2.firstInput = _ref;
            },
            type: 'text',
            value: hour,
            placeholder: '08',
            onKeyDown: this.onKeyPressHour,
            onChange: function onChange(e) {
              return _this2.onChange({ paramName: 'hour', value: e.target.value });
            },
            onFocus: this.onFocus
          }),
          React.createElement(
            'span',
            { className: 'colon' },
            ':'
          ),
          React.createElement('input', {
            className: 'gp-input minute',
            ref: function ref(_ref2) {
              _this2.secondInput = _ref2;
            },
            type: 'text',
            value: minute,
            placeholder: '00',
            onChange: function onChange(e) {
              return _this2.onChange({ paramName: 'minute', value: e.target.value });
            },
            onKeyDown: this.onKeyPressMinute,
            onFocus: this.onFocus
          }),
          showIncrementButtons && React.createElement(
            'span',
            {
              className: 'increment-button',
              onClick: function onClick() {
                _this2.increment('minute', parseInt(hour) === 0 && minute < incrementBy ? 5 : incrementBy);
              } },
            React.createElement(Icon, { icon: 'Plus', size: 10 })
          )
        ),
        showPeriod && React.createElement(
          'div',
          { className: 'period input-container' },
          React.createElement('input', {
            className: 'gp-input period',
            ref: function ref(_ref3) {
              _this2.periodInput = _ref3;
            },
            type: 'text',
            value: period,
            onChange: function onChange() {},
            onClick: this.onClickPeriod,
            onFocus: this.onFocus,
            onKeyDown: this.onKeyPressPeriod
          })
        )
      );
    }
  }]);

  return TimeInput;
}(PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getStateFromProps = function (props) {
    props = props || _this3.props;
    var state = {
      hour: props.hour,
      minute: props.minute,
      format: props.format || null,
      period: 'am',
      maxHour: props.format === '12h' ? 12 : props.maxHour || 23,
      minHour: props.format === '12h' ? 1 : props.minHour || 0,
      maxMinute: props.maxMinute || 59,
      minMinute: props.minMinute || 0,
      showPeriod: props.showPeriod || false,
      showIncrementButtons: props.showIncrementButtons || false,
      incrementBy: props.incrementBy || 15
    };
    state.showPeriod = !!(state.format === '12h' && state.showPeriod);

    var intHour = parseInt(state.hour || 0);
    var intMinute = parseInt(state.minute || 0);

    if (state.format === '12h') {
      var convertedHour = utils.datetime.convertHourTo12hFormat(state.hour);
      intHour = convertedHour.hour;
      state.period = convertedHour.period;
    }

    if (intHour > state.maxHour) {
      intHour = state.maxHour;
    } else if (intHour < state.minHour) {
      intHour = state.minHour;
    }

    if (intMinute > state.maxMinute) {
      intMinute = state.maxMinute;
    } else if (intMinute > state.maxMinute) {
      intMinute = state.maxMinute;
    }

    state.hour = utils.datetime.nbToStr2digit(intHour);
    state.minute = utils.datetime.nbToStr2digit(intMinute);

    return state;
  };

  this.isValid = function (paramName, value) {
    var min = paramName === 'hour' ? _this3.state.minHour : _this3.state.minMinute;
    var max = paramName === 'hour' ? _this3.state.maxHour : _this3.state.maxMinute;

    return utils.datetime.isHourOrMinuteBetweenLimits(value, min, max);
  };

  this.get2digitState = function () {
    var hour = utils.datetime.nbToStr2digit(_this3.isValid('hour', parseInt(_this3.state.hour)) ? parseInt(_this3.state.hour) : _this3.state.minHour);
    var minute = utils.datetime.nbToStr2digit(_this3.isValid('minute', parseInt(_this3.state.minute)) ? parseInt(_this3.state.minute) : _this3.state.minMinute);
    return { hour: hour, minute: minute };
  };

  this.getDataForParent = function () {
    var result = {
      paramName: _this3.props.paramName,
      value: {
        hour: _this3.state.format === '12h' ? utils.datetime.convertHourTo24hFormat(_this3.state.hour, _this3.state.period, _this3.state.maxHour) : parseInt(_this3.state.hour),
        minute: parseInt(_this3.state.minute)
      }
    };

    return result;
  };

  this.onChange = function (_ref4) {
    var paramName = _ref4.paramName,
        value = _ref4.value;

    if (!value) {
      return _this3.setState(_defineProperty({}, paramName, value));
    }

    if (!_this3.isValid(paramName, value)) {
      return;
    }

    if (paramName === 'hour' && value && value.length >= 2 && _this3.secondInput) {
      _this3.secondInput.focus();
    }

    if (paramName === 'minute' && value && value.length >= 2 && _this3.periodInput) {
      _this3.periodInput.focus();
    }

    _this3.setState(_defineProperty({}, paramName, value), function () {
      if (value.length >= 2) {
        _this3.props.onChange(_this3.getDataForParent());
      }
    });
  };

  this.onBlur = function (e) {
    var currentTarget = e.currentTarget;

    setTimeout(function () {
      /* avoid calling on blur when target is a child component (input) */
      if (currentTarget.contains(document.activeElement)) {
        return;
      }
      _this3.setState(_this3.get2digitState(), function () {
        if (!_this3.props.onChange) {
          return;
        }

        var propsData = { hour: _this3.props.hour, minute: _this3.props.minute };
        var stateData = _this3.getDataForParent().value;
        if (isEqual(propsData, stateData)) {
          return;
        }

        _this3.props.onChange(_this3.getDataForParent());
      });
    }, 0);
  };

  this.increment = function (paramName, i) {
    var currentValue = parseInt(_this3.state[paramName]);
    var nextState = _defineProperty({}, paramName, utils.number.incrementToNearestMultiple(currentValue, i));

    switch (paramName) {
      case 'hour':
        if (!_this3.isValid(paramName, nextState[paramName])) {
          nextState[paramName] = i > 0 ? _this3.state.minHour : _this3.state.maxHour;
        }

        if (i === -1 && nextState[paramName] === 11 || i === 1 && nextState[paramName] === 12) {
          nextState.period = _this3.getNewPeriod();
        }
        break;

      case 'minute':
        if (!_this3.isValid(paramName, nextState[paramName])) {
          /* increment | decrement hour when minute is over limit (reached maximum | minimum) */
          if (i > 0) {
            var reachedMaxmimum = !_this3.isValid('hour', parseInt(_this3.state.hour) + 1);
            nextState['minute'] = reachedMaxmimum ? _this3.state.maxMinute : _this3.state.minMinute;
            nextState['hour'] = reachedMaxmimum ? _this3.state.maxHour : parseInt(_this3.state.hour) + 1;
          } else {
            var reachedMinimum = !_this3.isValid('hour', parseInt(_this3.state.hour) - 1);
            /* default : reachedMinimum ? 00 : 60 - 15 */
            nextState['minute'] = reachedMinimum ? _this3.state.minMinute : _this3.state.maxMinute + 1 + i;
            nextState['hour'] = reachedMinimum ? _this3.state.minHour : parseInt(_this3.state.hour) - 1;
          }
        }
        break;
    }

    if (typeof nextState['minute'] !== 'undefined') {
      nextState['minute'] = utils.datetime.nbToStr2digit(nextState['minute']);
    }

    if (typeof nextState['hour'] !== 'undefined') {
      nextState['hour'] = utils.datetime.nbToStr2digit(nextState['hour']);
    }

    _this3.setState(nextState, function () {
      return _this3.props.onChange(_this3.getDataForParent());
    });
  };

  this.onKeyPressHour = function (e) {
    if (e.nativeEvent.keyCode === 13 || e.nativeEvent.keyCode === 39) {
      /* enter or right arrow */
      if (_this3.secondInput) {
        _this3.secondInput.focus();
      }
      e.preventDefault();
      /* this will only update and render if a modification is made : change hour "4" to "04" for example */
    } else if (e.nativeEvent.keyCode === 38) {
      /* keyup */
      _this3.increment('hour', 1);
    } else if (e.nativeEvent.keyCode === 40) {
      /* keydown */
      _this3.increment('hour', -1);
    }
  };

  this.onKeyPressMinute = function (e) {
    if (e.nativeEvent.keyCode === 13 || e.nativeEvent.keyCode === 39) {
      /* enter or right arrow */
      if (_this3.periodInput) {
        _this3.periodInput.focus();
      }
      e.preventDefault();
    } else if (e.nativeEvent.keyCode === 37) {
      /* left arrow */
      if (_this3.firstInput) {
        _this3.firstInput.focus();
      }
      e.preventDefault();
    } else if (e.nativeEvent.keyCode === 38) {
      /* keyup */
      _this3.increment('minute', 1);
    } else if (e.nativeEvent.keyCode === 40) {
      /* keydown */
      _this3.increment('minute', -1);
    }
  };

  this.onKeyPressPeriod = function (e) {
    var nextState = {};
    if (e.nativeEvent.keyCode === 65) {
      /* A */
      nextState.period = 'am';
    } else if (e.nativeEvent.keyCode === 80) {
      /* P */
      nextState.period = 'pm';
    } else if (e.nativeEvent.keyCode === 37) {
      /* left arrow */
      if (_this3.secondInput) {
        _this3.secondInput.focus();
      }
      e.preventDefault();
    } else if (e.nativeEvent.keyCode === 38 || e.nativeEvent.keyCode === 40) {
      /* keyup / keydown */
      nextState.period = _this3.getNewPeriod();
    }
    _this3.setState(nextState, function () {
      return _this3.props.onChange(_this3.getDataForParent());
    });
  };

  this.onClickPeriod = function (e) {
    utils.DOM.preventDefault(e);
    _this3.setState({ period: _this3.getNewPeriod() }, function () {
      return _this3.props.onChange(_this3.getDataForParent());
    });
  };

  this.getNewPeriod = function () {
    return _this3.state.period === 'am' ? 'pm' : 'am';
  };

  this.onFocus = function (event) {
    event.target.select();
  };
};

TimeInput.propTypes = propTypes;

export default TimeInput;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-ui/lib/TimeInput/index.js
// module id = 279
// module chunks = 0